import type { MouseEventHandler } from 'react';
import type { TagShort } from '@pages/User/components/tags/types';
import { type CellContext, createColumnHelper } from '@tanstack/react-table';

import { createdAtAccessor } from './shared';

const columnHelper = createColumnHelper<TagShort>();

export const getTagsTableColumns = ({
  handleEditTagClick,
}: {
  handleEditTagClick: (tag: TagShort) => MouseEventHandler<HTMLButtonElement> | undefined;
}) => [
  columnHelper.accessor('id', {
    id: 'id',
    enableColumnFilter: false,
    enableHiding: false,
  }),
  columnHelper.accessor('label', {
    id: 'label',
    enableColumnFilter: false,
    enableHiding: false,
    header: 'Label',
    sortingFn: 'text',
    sortUndefined: -1,
    filterFn: 'arrIncludesSome',
    meta: {
      tooltip: true,
    },
  }),
  createdAtAccessor(columnHelper),
  columnHelper.display({
    id: 'edit',
    header: '',
    enableHiding: false,
    enableColumnFilter: false,
    size: 65,
    minSize: 65,
    maxSize: 65,
    cell: (cellContext: CellContext<TagShort, unknown>) => (
      <button
        className="text-primary-600 hover:text-primary-900 cursor-pointer truncate font-light transition-colors"
        onClick={handleEditTagClick(cellContext.row.original)}
      >
        Edit
      </button>
    ),
    meta: {
      dataCellClassName: 'relative truncate whitespace-nowrap px-1 py-0 text-center text-sm font-medium',
    },
  }),
];
